import * as React from 'react';
import UiIcon from '@/ui/UiIcon/UiIcon';
import { dispatch } from './store';
import { openAnimation, closeAnimation } from './utils';
import { TOAST_TIMEOUT } from './constants';
import { ToastItem } from './types';

export default function Toast({
  id,
  type,
  text,
}: ToastItem) {
  const toast = React.useRef<HTMLDivElement>(null);

  const handleClose = React.useCallback(
    () => dispatch({ type: 'REMOVE_TOAST', id }),
    [id],
  );

  React.useEffect(() => {
    openAnimation(toast.current);

    const timeout = window.setTimeout(
      () => closeAnimation(
        toast.current,
        handleClose,
      ),
      TOAST_TIMEOUT,
    );

    return () => window.clearTimeout(timeout);
  }, [handleClose]);

  return (
    <div
      className={`toast toast-${type}`}
      ref={toast}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="toast-body">
        {text}
      </div>
      <button
        type="button"
        className="toast-close"
        aria-label="Close"
        onClick={() => closeAnimation(
          toast.current,
          handleClose,
        )}
      >
        <UiIcon name="close" />
      </button>
    </div>
  );
}
